import api from 'api'
import { setSessionToken, clearSessionToken } from 'api'
import { getProfile } from './profile'
import { formatPhone } from 'util/format'

export function signUp(details) {
  return (dispatch, getState) => {
    const { facebookAuth } = getState()
    return api.post('users', {
      user: {
        ...details,
        ...((facebookAuth && facebookAuth.authResponse && { password: facebookAuth.authResponse.accessToken, social_registration: {
          type: 'facebook',
          social_id: facebookAuth.authResponse.userID,
        }}) || {})
      }
    }).then(resp => {
      setSessionToken(resp.data.user.session_token)
      dispatch({ type: 'SET_USER', user: resp.data.user })
      dispatch(getProfile())
    })
  }
}

function handleSignInData(data) {
  return dispatch => {
    setSessionToken(data.session_token)
    if (window.FS) {
      window.FS.identify(data.profile_id)
    }
    dispatch({ type: 'SET_USER', user: data })
    return dispatch(getProfile()).then(() => {
      dispatch({ type: 'CLEAR_MFA' })
    })
  }
}

function mfaError(error, defaultMessage, clear) {
  return dispatch => {
    let message = defaultMessage
    if (error.response && error.response.data && error.response.data.errors) {
      const { errors } = error.response.data
      if (errors.includes('mfa.too_many_sends')) {
        clear = true
        message = 'You’ve attempted to send this code too many times. Please reach out to Support for assistance.'
      } else if (errors.includes('mfa.code_expired')) {
        clear = true
        message = 'Sign in expired. Please log in again.'
      } else if (errors.includes('mfa.invalid_method')) {
        clear = true
        message = 'The requested method for verification code is invalid.'
      } else if (errors.includes('mfa.incorrect_code')) {
        clear = false
        message = 'Invalid code. Try again.'
      }
    }
    dispatch({ type: 'SET_FLASH', flash: { id: 'mfa', type: 'error', message }})
    if (clear) {
      dispatch({ type: 'CLEAR_MFA' })
    }
  }
}

export function verifyMFA(mfa_guid, mfa_code) {
  return dispatch => {
    return api.version(3).patch(`session/verifications/${mfa_guid}`, { mfa_code }).then(resp => {
      return dispatch(handleSignInData(resp.data))
    }).catch(resp => {
      return dispatch(mfaError(resp, 'Something went wrong. Please check your connection and try again.', false))
    })
  }
}

export function sendMFA(mfa_guid, mfa_method='sms') {
  return dispatch => {
    return api.version(3).patch(`session/verifications/${mfa_guid}`, { mfa_method }).then(resp => {
      let { sent_to } = resp.data
      if (mfa_method === 'sms') {
        sent_to = formatPhone(sent_to)
      }
      dispatch({ type: 'SET_FLASH', flash: { 
        id: 'mfa',
        type: 'success', 
        message: `A text message with the verification code has been sent to ${sent_to}`
      }})
      dispatch({ type: 'SET_MFA', guid: mfa_guid, method: mfa_method, sent_to, sent_on: new Date().toISOString() })
    }).catch(error => {
      return dispatch(mfaError(error, 'Could not send verification code.', true))
    })
  }
}

export function signIn(credentials) {
  return dispatch => {
    return api.post('user/session', credentials)
      .then(resp => {
        if (resp.data.mfa_required && resp.data.mfa_guid) {
          return dispatch(sendMFA(resp.data.mfa_guid))
        } else {
          return dispatch(handleSignInData(resp.data))
        }
      })
      .catch(e => {
        if (e.response.status === 409) {
          dispatch({
            type: 'SET_FLASH',
            flash: { type: 'error', message: `It looks like you signed up with Facebook, which is no longer supported. Use “Forgot Password?” to reset your password.` },
          })
        } else throw e
      })
  }
}

export function signInWithToken(token, ephemeral) {
  return dispatch => {
    clearSessionToken()
    return api.post('user/session', { token })
      .then(resp => {
        setSessionToken(resp.data.session_token)
        if (window.FS) {
          window.FS.identify(resp.data.profile_id)
        }
        dispatch({ type: 'SET_USER', user: resp.data, ephemeral })
        return dispatch(getProfile())
      })
  }
}

export function forgotPassword(email) {
  return dispatch => {
    return api.put('user/password/reset', { email }, { headers: { Accept: 'application/json' } })
  }
}

export function resetPassword(data) {
  return dispatch => {
    return api.put('user/password', data)
  }
} 

export function signOut({ message } = {}) {
  return dispatch => {
    api.version(3).delete('session')
    clearSessionToken()
    if (window.FS) {
      window.FS.identify(false)
    }
    dispatch({ type: 'SIGN_OUT' })
    if (message) {
      setTimeout(() => {
        dispatch({ type: 'SET_FLASH', flash: { type: 'alert', message } })
      }, 1000)
    }
  }
}